// navItems.ts
import { UserStatus } from "@api/graphql";
import {
  ArchiveBooksIcon,
  DrawerUploadIcon,
  FileTextClockIcon,
  MonitorConfig,
  MultiplePeopleIcon,
  NotesPaperTextIcon,
} from "@assets/icons";
import { ResaleSubmissionRoles, Role } from "@roles";

import { ROUTES } from "../../routes";

interface NavItem {
  to: string;
  groups?: Role[];
  user_status?: UserStatus;
  text: string;
  icon: string;
}

export const navItems: NavItem[] = [
  {
    to: ROUTES.Dashboard.Accounts.path,
    groups: [Role.MemberServices, Role.VisualArtistAdmin, Role.Data],
    text: "Accounts",
    icon: MultiplePeopleIcon,
  },
  {
    to: ROUTES.Dashboard.ReportNewResale.path,
    groups: ResaleSubmissionRoles,
    text: "Report new resale",
    user_status: UserStatus.ACTIVE,
    icon: DrawerUploadIcon,
  },
  {
    to: ROUTES.Dashboard.RecentReports.path,
    groups: [Role.Data],
    user_status: UserStatus.ACTIVE,
    text: "Recent reports submitted",
    icon: ArchiveBooksIcon,
  },
  {
    to: ROUTES.Dashboard.UnderReview.path,
    groups: [Role.ResaleReporter],
    user_status: UserStatus.ACTIVE,
    text: "Under review",
    icon: FileTextClockIcon,
  },
  {
    to: ROUTES.Dashboard.PendingPayments.path,
    groups: [Role.ResaleReporter],
    user_status: UserStatus.ACTIVE,
    text: "Pending payments",
    icon: NotesPaperTextIcon,
  },
  {
    to: ROUTES.Dashboard.ReportsToReview.path,
    groups: [Role.VisualArtistAdmin, Role.Data],
    user_status: UserStatus.ACTIVE,
    text: "Reports to review",
    icon: FileTextClockIcon,
  },
  {
    to: ROUTES.Dashboard.HoldPeriod.path,
    groups: [Role.VisualArtistAdmin, Role.Data],
    user_status: UserStatus.ACTIVE,
    text: "Hold period",
    icon: NotesPaperTextIcon,
  },
  {
    to: ROUTES.Dashboard.PastReports.path,
    groups: [Role.MemberServices, Role.VisualArtistAdmin, Role.Data],
    user_status: UserStatus.ACTIVE,
    text: "Past reports",
    icon: ArchiveBooksIcon,
  },
  {
    to: ROUTES.Dashboard.PastResaleReports.path,
    groups: [Role.ResaleReporter],
    user_status: UserStatus.ACTIVE,
    text: "Past resale reports",
    icon: ArchiveBooksIcon,
  },
  {
    to: ROUTES.Dashboard.UpcomingRoyalties.path,
    groups: [Role.RoyaltyRecipient],
    user_status: UserStatus.ACTIVE,
    text: "Future royalties",
    icon: FileTextClockIcon,
  },
  {
    to: ROUTES.Dashboard.PastPayments.path,
    groups: [Role.RoyaltyRecipient],
    user_status: UserStatus.ACTIVE,
    text: "Past payments",
    icon: ArchiveBooksIcon,
  },
  {
    to: ROUTES.Dashboard.Profile.path,
    groups: [Role.ResaleReporter, Role.RoyaltyRecipient],
    user_status: UserStatus.ACTIVE,
    text: "Account details",
    icon: MonitorConfig,
  },
];
